"use client";

import Link from "next/link";
import Logo from "../../../../public/images/icons/Logo.svg?url";
import ImageWithFallback from "@/components/common/ImageWithFallback";

const HeaderLogo = () => {
  return (
    <Link prefetch={false} href="/" title="GSF" className="logo">
      <ImageWithFallback
        alt="GSF"
        src={Logo}
        width={74}
        height={74}
        unoptimized
        loading="eager"
      />
    </Link>
  );
};

export default HeaderLogo;
